package de.ohhhmhhh.backend.models.model.text

import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StaticTextEntity(
    @SerialName("id")
    val id: String,
    @SerialName("version")
    val version: Int,
    @SerialName("type")
    val type: StaticTextTypeEntity,
    @SerialName("created")
    val created: Instant,
    @SerialName("title")
    val title: String,
    @SerialName("content")
    val content: String
)